/**
 * Which template fields are signing CEREMONY rather than questions.
 *
 * Every consent form carried its own printed-name box, typed-signature
 * box, signature-date box, and a full witness block — and the lien
 * added provider and attorney slots. A PI patient performed ~50 acts
 * of pure ceremony across the bundle (typed their own name 8 times).
 * These fields are now invisible to the patient: the Review & Sign
 * step captures one name + one drawn signature and applies it to each
 * acknowledged form, and the server backfills the printed-name / date
 * fields so the rendered PDFs are unchanged.
 *
 * Deliberately NOT filtered: real questions that mention people —
 * e.g. the PI intake's attorney_name (the patient telling us who
 * their lawyer is). The attorney/provider rule below only applies to
 * signature-required templates, where those ids are signing slots.
 */

export function isCeremonyField(field, template) {
  if (!field || typeof field !== 'object') return false;
  if (field.type === 'signature' || field.type === 'signature_slot') return true;
  const id = String(field.id || '').toLowerCase();
  const label = String(field.label || '').toLowerCase();
  if (!id) return false;
  if (id.includes('witness') || label.includes('witness signature')) return true;
  if (/_sig$|_signature$/.test(id)) return true;
  if (/_printed$|_printed_name$/.test(id)) return true;
  if (/sign_date|sig_date|signature_date/.test(id)) return true;
  // A bare required "Date" on a signature-required form is the signing
  // date by another name (HIPAA's hipaa_date, found in the 7/31
  // staging walkthrough) — server backfills it from the signing event.
  if (template?.requires_signature && field.type === 'date'
    && /^date$|_date$/.test(id) && /^(date|fecha)$/i.test(label.trim())) {
    return true;
  }
  if (template?.requires_signature
    && /^(attorney|provider)_(printed|printed_name|name|bar|bar_number|sign_date|sig|signature|title)$/.test(id)) {
    return true;
  }
  return false;
}

export function visibleIntakeFields(fields, template) {
  const arr = Array.isArray(fields) ? fields : [];
  return arr.filter((f) => !isCeremonyField(f, template));
}
